import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import StatesDrawer from "components/drawer/StateDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

const StatesTable = ({ statesdata, hideDelete, hideEdit }) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <StatesDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {statesdata?.slice(0).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>

            <TableCell className="text-center text-xs">{data.name}</TableCell>
            <TableCell className="text-center text-xs">
              {data.country_name}
              {/* {console.log(data.country_name)} */}
            </TableCell>

            {hideEdit  && (
              <TableCell>
                <div className="flex justify-center">
                  <EditDeleteButton
                    title={data.name}
                    id={data.id_state}
                    handleUpdate={handleUpdate}
                    handleModalOpen={handleModalOpen}
                    hideEdit={hideEdit}
                    // hideDelete={hideDelete}
                  />
                </div>
              </TableCell>
            )}
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default StatesTable;
